import { render, staticRenderFns } from "./ExpenseProvidersTable.vue?vue&type=template&id=251af285&scoped=true"
import script from "./ExpenseProvidersTable.vue?vue&type=script&lang=js"
export * from "./ExpenseProvidersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251af285",
  null
  
)

export default component.exports